import { createGlobalStyle } from 'styled-components';
import { zezamiiNeutral } from './brandTokens';

const GlobalStyles = createGlobalStyle`
html {
	overflow: hidden;
}
body {
	margin: 0;
	background: ${zezamiiNeutral.grey50};
	color: ${zezamiiNeutral.grey900};
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
body, html {
	scrollbar-width: thin;
}

:root {
	--scrollbar-size: 6px;
	--scrollbar-thumb: ${zezamiiNeutral.grey400};
	--scrollbar-thumb-hover: ${zezamiiNeutral.grey500};
	--scrollbar-track: transparent;
	scrollbar-width: thin;
}

::-webkit-scrollbar {
	width: var(--scrollbar-size);
	height: var(--scrollbar-size);
}
::-webkit-scrollbar-thumb {
	background-color: var(--scrollbar-thumb);
	border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
	background-color: var(--scrollbar-thumb-hover);
}
::-webkit-scrollbar-track {
	background: var(--scrollbar-track);
}

* {
	scrollbar-width: thin;
	scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}
`;

export default GlobalStyles;
